/**
 * Hierarchical rollup keywords from API: legacy strings or scored rows { keyword, weight, score }.
 */

export function parseHierarchicalKeywordLabels(keywords) {
    if (!Array.isArray(keywords)) return [];
    return keywords
        .map(k => {
            if (typeof k === 'string') return k.trim();
            if (k && typeof k === 'object' && typeof k.keyword === 'string') return k.keyword.trim();
            return '';
        })
        .filter(Boolean);
}

export function hasHierarchicalKeywords(keywords) {
    return parseHierarchicalKeywordLabels(keywords).length > 0;
}

/**
 * Multi-line tooltip text (scores when present).
 */
export function hierarchicalKeywordsTooltipContent(keywords) {
    if (!Array.isArray(keywords) || keywords.length === 0) return '';

    const lines = keywords.map(k => {
        if (typeof k === 'string') return k.trim();
        if (k && typeof k === 'object' && k.keyword) {
            const score = k.score != null && !Number.isNaN(Number(k.score)) ? Number(k.score).toFixed(2) : null;
            return score ? `${k.keyword} (${score})` : String(k.keyword);
        }
        return '';
    })
        .map(s => s.trim())
        .filter(Boolean);

    return lines.join('\n');
}
